
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from '@/views/a-pedidos-ml/pc/lista/controlador';

    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorSeccion;
        public get Total() { return this.Controlador.PendientesMla; }
        public get Cargando() { return this.Controlador.BuscandoPendientesMLA; }

        protected Intervalo: any = null;

        beforeDestroy()
        {
            clearInterval( this.Intervalo );
        }


        mounted()
        {
            this.Recargar();
            this.Intervalo = setInterval( () => { this.Recargar(); }, 15000 );
        }

        async Recargar( )
        {
            await this.Controlador.BuscarPendientes();
        }

        async Ver()
        {
            this.Controlador.Buscador.Filtros.Valores.Tag = this.Controlador.Buscador.Filtros.Tags.findIndex( x => x.Id == 'pendientes_mla' );
            this.Controlador.Buscador.Buscar( 1 );
        }
    }
